<template>
  <div class="find-password-bg">
    <div class="find-password-card">
      <div class="find-password-content">
        <div class="form-container">
          <div class="form-title">找回密码</div>
          <el-form :model="form" :rules="rules" ref="passwordForm" label-width="0">
            <!-- 手机号码输入 -->
            <el-form-item prop="mobile">
              <el-input placeholder="请输入手机号" v-model="form.mobile">

                <el-select v-model="select" slot="prepend" placeholder="请选择" style="width:100px;">
                  <el-option v-for="(item,index) in areaCodeList" :key="index" :label="'+'+ item.code "
                             :value="item.code">{{ item.country }} +{{ item.code }}
                  </el-option>
                </el-select>

              </el-input>
            </el-form-item>

            <!-- 验证码输入 -->
            <el-form-item prop="code">
              <el-row :gutter="10">
                <el-col :span="14">
                  <el-input v-model="form.code" placeholder="请输入验证码" maxlength="6">
                    <template #prefix>
                      <img class="input-icon" src="@/static/login/code.png" alt=""/>
                    </template>
                  </el-input>
                </el-col>
                <el-col :span="10">
                  <el-button :disabled="time > 0" @click="getCode" class="btn-code">
                    {{ time > 0 ? time + '秒后重试' : '获取验证码' }}
                  </el-button>
                </el-col>
              </el-row>
            </el-form-item>

            <!-- 新密码输入 -->
            <el-form-item prop="password">
              <el-input v-model="form.password" placeholder="请输入新密码" type="password" show-password>
                <template #prefix>
                  <img class="input-icon" src="@/static/login/pas.png" alt=""/>
                </template>
              </el-input>
            </el-form-item>

            <!-- 确认密码输入 -->
            <el-form-item prop="confirmPassword">
              <el-input v-model="form.confirmPassword" placeholder="请再次输入新密码" type="password" show-password>
                <template #prefix>
                  <img class="input-icon" src="@/static/login/pas.png" alt=""/>
                </template>
              </el-input>
            </el-form-item>

            <!-- 提交按钮 -->
            <el-button type="primary" class="btn-submit" @click="submitForm">提交</el-button>
          </el-form>

          <!-- 返回登录链接 -->
          <!--          <div class="login-link">-->
          <!--            <span class="link-text" @click="goLogin">返回登录</span>-->
          <!--          </div>-->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {forget_password, sendSmsCode} from "@/api/modules/user";
import {getAreaCode} from "@/api/modules/common";

export default {
  name: "find-password",
  data() {
    return {
      time: 0,
      timer: null,
      form: {
        mobile: "",
        code: "",
        password: "",
        confirmPassword: "",
      },
      select: "86",
      areaCodeList: [],
      rules: {
        mobile: [
          {required: true, message: "请输入手机号码", trigger: "blur"},
          {pattern: /^1[3-9]\d{9}$/, message: "请输入正确的手机号码", trigger: "blur"},
        ],
        code: [
          {required: true, message: "请输入验证码", trigger: "blur"},
          {min: 4, max: 6, message: "验证码长度应为4-6位", trigger: "blur"},
        ],
        password: [
          {required: true, message: "请输入新密码", trigger: "blur"},
          {min: 6, message: "密码长度不能少于6位", trigger: "blur"},
        ],
        confirmPassword: [
          {required: true, message: "请再次输入新密码", trigger: "blur"},
          {
            validator: (rule, value, callback) => {
              if (value !== this.form.password) {
                callback(new Error("两次输入密码不一致"));
              } else {
                callback();
              }
            }, trigger: "blur"
          },
        ],
      },
    };
  },
  beforeDestroy() {
    if (this.timer) clearInterval(this.timer);
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      getAreaCode().then(res => {
        if (res.data.code == 10000) {
          this.areaCodeList = res.data.data
        }
      })
    },
    getCode() {
      if (!/^1[3-9]\d{9}$/.test(this.form.mobile)) {
        this.$message.error("请先输入正确的手机号码");
        return;
      }
      this.time = 60;
      this.timer = setInterval(() => {
        this.time--;
        if (this.time <= 0) {
          clearInterval(this.timer);
        }
      }, 1000);

      sendSmsCode({mobile: this.form.mobile, type: '3'}).then(res => {
        if (res.data.code != 10000) {
          this.$message({
            type: 'error',
            message: res.data.message
          })
        } else {
          this.$message.success("验证码已发送");
        }
      })
    },

    submitForm() {
      this.$refs.passwordForm.validate(async (valid) => {
        if (!valid) return;
        try {
          const res = await forget_password({
            mobile: this.form.mobile,
            code: Number(this.form.code),
            password: this.form.password,
            mobile_prefix: this.select
          });
          if (res.data.code === 10000) {
            // 刷新成功，显示成功消息并跳转到登录页面
            this.$message.success("密码刷新成功");
            setTimeout(() => {
              this.$router.push("/login");
            }, 1500);
          } else {
            this.$message.error(res.data.message || "刷新失败");
          }
        } catch (e) {
          this.$message.error("请求失败");
        }
      });
    },

    goLogin() {
      this.$router.push("/login");
    },
  },
};
</script>

<style lang="scss" scoped>
.find-password-bg {
  min-height: 100vh;
  background: url("../../../static/login/login-bj.png") no-repeat center center;
  background-size: 100% 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.find-password-card {
  width: 420px;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 4px 32px 0 rgba(0, 0, 0, 0.08);
  padding: 36px 36px 28px 36px;
  box-sizing: border-box;
}

.find-password-content {
  min-height: 220px;
}

.form-container {
  padding: 20px 0;
}

.form-title {
  font-size: 24px;
  font-weight: 600;
  color: #222;
  margin-bottom: 30px;
  text-align: center;
}

.input-icon {
  width: 16px;
  height: 16px;
}

.btn-code {
  width: 100%;
  padding: 0 8px;
  height: 40px;
  line-height: 40px;
  border-radius: 4px;
  background: #409EFF;
  color: #fff;
  font-size: 14px;
  font-weight: 500;
  border: none;
}

.btn-submit {
  width: 100%;
  margin-top: 18px;
  height: 40px;
}

.login-link {
  text-align: center;
  margin-top: 20px;
}

.link-text {
  color: #409EFF;
  cursor: pointer;
  font-size: 14px;

  &:hover {
    text-decoration: underline;
  }
}
</style>
